import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PrestasiService from "../../services/PrestasiService";
import {message,notification} from "antd";
import {AUTH_ID_PENDAFTAR, AUTH_NOMOR_PENDAFTARAN, AUTH_TOKEN} from "../../constants/AuthConstant";
import prestasiService from "../../services/PrestasiService";


export const initialState = {
    loading: false,
    showMessage:false,
    message:'',
    statusPostPrestasi:'',
    messagePostPrestasi:'',
    loadingPostPrestasi:false,
    dataPrestasi:[],
    loadingDelete:false,
    statusDelete:'',
    loadingUpdate:false,
    statusUpdate:'',
    loadingDataPrestasiUpdate:false,
    statusDataPrestasiUpdate:'',
}


export const getDataPrestasi = createAsyncThunk('transaksi/prestasi',async (data, { rejectWithValue }) => {
    try {
        const response = await prestasiService.getData(localStorage.getItem(AUTH_TOKEN),localStorage.getItem(AUTH_NOMOR_PENDAFTARAN))
        //console.log(JSON.stringify(response))
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postPrestasi = createAsyncThunk('transaksi/prestasi/store',async (data, { rejectWithValue }) => {
    try {
        const response = await prestasiService.post(localStorage.getItem(AUTH_TOKEN),data)
        console.log(JSON.stringify(response))
        if(response.success!=true){
            notification.error({
                message: 'Perhatian',
                className:"text-danger",
                description:response.message||'error',
                duration:3
            });
        }else {
            message.success(response.message,3);
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})


export const prestasiDelete = createAsyncThunk('transaksi/prestasi/delete',async (data, { rejectWithValue }) => {
    const {id}=data;
    try {
        const response = await PrestasiService.delete(localStorage.getItem(AUTH_TOKEN),{id:id})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const prestasiUpdate = createAsyncThunk('transaksi/prestasi/update',async (data, { rejectWithValue }) => {
    const {step}=data;
    try {
        const response = await PrestasiService.update(localStorage.getItem(AUTH_TOKEN),{step:step,back:true})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            if(response.message) {
                message.success(response.message, 3);
            }
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const prestasiDataUpdate = createAsyncThunk('transaksi/prestasi/data/update',async (data, { rejectWithValue }) => {
    const {step}=data;
    try {
        const response = await PrestasiService.update(localStorage.getItem(AUTH_TOKEN),{step:step,back:false})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            if(response.message) {
                message.success(response.message, 3);
            }
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})


export const prestasiSlice = createSlice({
    name: 'prestasi',
    initialState,
    reducers: {
            postPrestasiSuccess: (state, action) => {
                state.loadingPostPrestasi = false
                state.statusPostPrestasi = action.payload.success
                state.messagePostPrestasi=action.payload.message
            },
            showLoadingPostPrestasi: (state) => {
                state.loadingPostPrestasi = true
            },
            showLoadingUpdatePrestasi: (state) => {
                state.loadingUpdate = true
            },
            showLoadingUpdateDataPrestasi: (state) => {
                state.loadingUpdate = true
            },
        },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPrestasi.fulfilled, (state, action) => {
                state.loading = false
                state.dataPrestasi = action.payload
            })
            .addCase(getDataPrestasi.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPrestasi.rejected, (state, action) => {
                state.loading = false
                state.dataPrestasi = action.payload
            })
            .addCase(postPrestasi.fulfilled, (state, action) => {
                state.loadingPostPrestasi = false
                state.statusPostPrestasi = action.payload.success
            })
            .addCase(postPrestasi.pending, (state) => {
                state.loadingPostPrestasi = true
            })
            .addCase(postPrestasi.rejected, (state, action) => {
                state.messagePostPrestasi = action.payload.message
                state.showMessage = true
                state.loadingPostPrestasi = false
                state.statusPostPrestasi = action.payload.success
            })
            .addCase(prestasiDelete.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(prestasiDelete.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(prestasiDelete.rejected, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(prestasiUpdate.fulfilled, (state, action) => {
                state.loadingUpdate = false
                state.statusUpdate = action.payload.success
            })
            .addCase(prestasiUpdate.pending, (state) => {
                state.loadingUpdate = true
            })
            .addCase(prestasiUpdate.rejected, (state, action) => {
                state.loadingUpdate = false
                state.statusUpdate = action.payload.success
            })
            .addCase(prestasiDataUpdate.fulfilled, (state, action) => {
                state.loadingDataPrestasiUpdate = false
                state.statusDataPrestasiUpdate = action.payload.success
            })
            .addCase(prestasiDataUpdate.pending, (state) => {
                state.loadingDataPrestasiUpdate = true
            })
            .addCase(prestasiDataUpdate.rejected, (state, action) => {
                state.loadingDataPrestasiUpdate = false
                state.statusDataPrestasiUpdate = action.payload.success
            })
    },
})

export const {
    postPrestasiSuccess,
    showLoadingPostPrestasi,
    showLoadingUpdatePrestasi,
    showLoadingUpdateDataPrestasi
} = prestasiSlice.actions

export default prestasiSlice.reducer
